/**
 * Created by Karol Kluska on 14.09.17.
 */

angular
  .module('app')
  .component('ngFooter', {
    templateUrl: 'app/components/bookingEngine/footer/Footer.html',
    controller: Footer
  });

/** @ngInject */
function Footer() {

}

Footer.prototype = {};
